import { useEffect } from 'react';
import { Box, Container, useTheme } from '@mui/material';
import { Header } from './Header';
import Footer from './Footer';
import { Head, usePage } from '@inertiajs/react';
import ErrorBoundary from '../../components/ErrorBoundary';
import { useCsatSurvey } from '../../hooks/useCsatSurvey';
import { useRatesSurvey } from '../../hooks/useRatesSurvey';
import CSAT from '../../components/surveys/CSAT';
import Rates from '../../components/surveys/Rates';

const AVAILABLE_LANGUAGES = ["en", "es", "vi", "zh"];

function SvceLayout({ children }) {
  const theme = useTheme();
  const {
    props: { lang, title, meta = [] },
  } = usePage();

  useEffect(() => {
    const switchLanguage = () => {
      if (typeof Weglot !== 'undefined' && AVAILABLE_LANGUAGES.some((available => lang === available))) {
        Weglot.switchTo(lang)
      }
    };

    if (document.readyState === 'complete') {
      switchLanguage();
    } else {
      window.addEventListener("load", switchLanguage);
      return () => window.removeEventListener("load", switchLanguage);

    }
  }, [lang]);

  const csat = useCsatSurvey();
  const rates = useRatesSurvey();


  return (
    <>
      <Head>
        {[
          title && <title key={title}>{title}</title>,
          ...meta.map(({ ...attrs }) => <meta key={attrs.name || attrs.property} {...attrs} />),
        ].filter((tag) => tag)}
      </Head>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Container maxWidth={false} disableGutters sx={{ flexGrow: 1 }}>
          <Header />
          <Box sx={{ p: { xs: 1, sm: 3 } }}>
            <Box
              sx={{
                backgroundColor: theme.palette.common.white,
                borderRadius: theme.shape.svceBorderRadius,
              }}
            >
              <ErrorBoundary>{children}</ErrorBoundary>
            </Box>
          </Box>
          <Footer />
        </Container>
        {csat.show && <CSAT onDismiss={csat.dismiss} />}
        {rates.show && <Rates onDismiss={rates.dismiss} />}
      </Box>
    </>
  );
}

export default (page) => <SvceLayout>{page}</SvceLayout>;
